// Waves are ALWAYZ!!! 11 by 5 ( right now :P )
export const Waves = [
    [
        [1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1],
        [2, 2, 2, 2, 2, 0, 2, 2, 2, 2, 2],
        [3, 3, 3, 3, 3, 0, 3, 3, 3, 3, 3],
        [0, 4, 4, 4, 0, 0, 0, 4, 4, 4, 0],
        [0, 4, 0, 4, 0, 0, 0, 4, 0, 4, 0],
    ],
    [
        [0, 2, 0, 0, 0, 3, 0, 0, 0, 2, 0],
        [0, 4, 0, 0, 0, 1, 0, 0, 0, 4, 0],
        [4, 6, 4, 0, 1, 7, 1, 0, 4, 6, 4],
        [2, 4, 2, 0, 3, 1, 3, 0, 2, 4, 2],
        [4, 2, 4, 0, 1, 3, 1, 0, 4, 2, 4],
    ],
    [
        [0, 0, 0, 3, 2, 1, 2, 3, 0, 0, 0],
        [0, 0, 3, 2, 1, 1, 1, 2, 3, 0, 0],
        [0, 3, 2, 1, 1, 4, 1, 1, 2, 3, 0],
        [0, 0, 3, 2, 1, 1, 1, 2, 3, 0, 0],
        [0, 0, 0, 3, 2, 1, 2, 3, 0, 0, 0],
    ],
    [
        [1, 2, 3, 4, 5, 8, 5, 4, 3, 2, 1],
        [0, 1, 2, 3, 4, 5, 4, 3, 2, 1, 0],
        [0, 0, 1, 2, 3, 4, 3, 2, 1, 0, 0],
        [0, 0, 0, 1, 2, 3, 2, 1, 0, 0, 0],
        [0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0],
    ],
    [
        [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0],
        [4, 0, 4, 0, 4, 0, 4, 0, 4, 0, 4],
        [0, 3, 0, 3, 0, 3, 0, 3, 0, 3, 0],
        [6, 0, 6, 0, 6, 0, 6, 0, 6, 0, 6],
        [0, 7, 0, 7, 0, 7, 0, 7, 0, 7, 0],
    ],
    [
        [0, 0, 0, 8, 0, 0, 0, 8, 0, 0, 0],
        [0, 0, 8, 6, 8, 0, 8, 6, 8, 0, 0],
        [0, 8, 6, 4, 6, 8, 6, 4, 6, 8, 0],
        [8, 6, 4, 2, 4, 6, 4, 2, 4, 6, 8],
        [6, 4, 2, 0, 2, 4, 2, 0, 2, 4, 6],
    ],
];
